export const createUserType = (set, get) => ({
    userType: "",
    setUserType: (userType) => set( userType ),
});



// WEBPACK FOOTER //
// ./src/store/slices/User_Type/userTypeSlice.js